/**
 * Resolves a human-friendly label for a user/identity, preferring the mapped
 * display name, then the login identifier (email / UPN), and finally falling
 * back to the raw external id. Names are resolved server-side so the UI never
 * has to look an identity up by external id.
 */
export interface IdentityLabelFields {
  identityDisplayName?: string | null;
  identityIdentifier?: string | null;
  identityId?: string | null;
}

export function identityLabel(fields: IdentityLabelFields): string {
  const displayName = fields.identityDisplayName?.trim();
  if (displayName) return displayName;
  const identifier = fields.identityIdentifier?.trim();
  if (identifier) return identifier;
  return fields.identityId?.trim() || "—";
}
